<template>
  <div class="p-3" id="benefit-card" :style="style">
    <div class="d-flex flex-row">
      <span class="material-symbols-outlined text-white fw-lighter">
        {{ info?.thumbnailIcon }}
      </span>
      <h1 class="ms-1">{{ info?.thumbnailTitle }}</h1>
    </div>
    <p class="text-start w-75" :innerHTML="info?.thumbnailDescription" />
    <button v-if="info?.thumbnailCTA" class="text-center" @click="onCTA">
      <span class="w-100"
        >{{ info.thumbnailCTA }}
        <i class="fa fa-chevron-right float-end"></i>
      </span>
    </button>
    <a
      v-if="info?.thumbnailUrl"
      :href="info?.thumbnailUrl"
      target="_blank"
      class="cta-overlay"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";
import { MasterCardBenefit } from "@/apps/credit-line/types/responses";
import useAsset from "@/apps/credit-line/helpers/useAsset";

export default defineComponent({
  name: "BenefitItem",
  props: {
    info: Object as PropType<MasterCardBenefit>,
  },
  emits: ["cta"],
  setup(props, { emit }) {
    const onCTA = () => {
      emit("cta");
    };

    const style = computed(() => ({
      backgroundImage: `url(${useAsset(
        `img/credit-line/${props.info?.id}.webp`
      )}), url(${useAsset(`img/credit-line/benefit.png`)})`,
      backgroundSize: "cover",
    }));
    return { onCTA, style };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
#benefit-card {
  position: relative;
  min-height: 11rem;
  background: linear-gradient(
    90deg,
    #0d4121 0%,
    #0e5c2c 0%,
    rgba(0, 0, 0, 0.49) 100%
  );
  border-radius: 0.625rem;

  & h1 {
    color: white;
    font-family: Inter;
    font-size: 1.0625rem;
    font-style: normal;
    font-weight: 700;
  }

  & p {
    color: white;
    font-family: Inter;
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 500;
  }

  & button {
    color: $pj-color-green;
    border-radius: 0.6875rem;
    border: none;
    font-weight: 600;
    background: #9bc31e;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.32);
    display: flex;
    width: 6.625rem;
    height: 1.4375rem;
    align-items: center;
    & i {
      margin-top: 3.2%;
      scale: 0.9;
    }
  }
}

.cta-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
}

.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 200, "GRAD" 0, "opsz" 24;
}
</style>
